// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file forms/v1/forms.proto (package forms.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import type { Field } from './field_pb'
import { file_forms_v1_field } from './field_pb'
import type {
  BatchDeleteSubmissionRequestSchema,
  BatchDeleteSubmissionResponseSchema,
  BatchGetSubmissionSummariesRequestSchema,
  BatchGetSubmissionSummariesResponseSchema,
  DeleteSubmissionRequestSchema,
  DeleteSubmissionResponseSchema,
  DownloadSubmissionsCSVRequestSchema,
  GetLiveResultsRequestSchema,
  GetLiveResultsResponseSchema,
  ListSubmissionsRequestSchema,
  ListSubmissionsResponseSchema,
  SubmissionsSummaryRequestSchema,
  SubmissionsSummaryResponseSchema,
  SubmitFormRequestSchema,
  SubmitFormResponseSchema
} from './form_submission_pb'
import { file_forms_v1_form_submission } from './form_submission_pb'
import type { PaginationOptions } from './options_pb'
import { file_forms_v1_options } from './options_pb'
import type { SuccessAction } from './success_screen_pb'
import { file_forms_v1_success_screen } from './success_screen_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import type { HttpBodySchema } from '../../google/api/httpbody_pb'
import { file_google_api_httpbody } from '../../google/api/httpbody_pb'
import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_timestamp } from '@bufbuild/protobuf/wkt'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file forms/v1/forms.proto.
 */
export const file_forms_v1_forms: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_common_v1_annotations,
      file_forms_v1_field,
      file_forms_v1_form_submission,
      file_forms_v1_options,
      file_forms_v1_success_screen,
      file_google_api_annotations,
      file_google_api_httpbody,
      file_google_protobuf_timestamp
    ]
  )

/**
 * @generated from message forms.v1.Form
 */
export type Form = Message<'forms.v1.Form'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: bool active = 2;
   */
  active: boolean

  /**
   * @generated from field: forms.v1.SuccessAction success_action = 3;
   */
  successAction?: SuccessAction

  /**
   * @generated from field: repeated forms.v1.Field fields = 4;
   */
  fields: Field[]

  /**
   * @generated from field: string title = 5;
   */
  title: string

  /**
   * @generated from field: string description = 6;
   */
  description: string

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp

  /**
   * @generated from field: optional string action_text = 9;
   */
  actionText?: string

  /**
   * @generated from field: repeated forms.v1.Rule rules = 10;
   */
  rules: Rule[]
}

/**
 * Describes the message forms.v1.Form.
 * Use `create(FormSchema)` to create a new message.
 */
export const FormSchema: GenMessage<Form> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 0)

/**
 * @generated from message forms.v1.CreateFormResponse
 */
export type CreateFormResponse = Message<'forms.v1.CreateFormResponse'> & {
  /**
   * @generated from field: forms.v1.Form form = 1;
   */
  form?: Form
}

/**
 * Describes the message forms.v1.CreateFormResponse.
 * Use `create(CreateFormResponseSchema)` to create a new message.
 */
export const CreateFormResponseSchema: GenMessage<CreateFormResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 1)

/**
 * @generated from message forms.v1.CreateFormRequest
 */
export type CreateFormRequest = Message<'forms.v1.CreateFormRequest'> & {
  /**
   * @generated from field: forms.v1.SuccessAction success_action = 1;
   */
  successAction?: SuccessAction

  /**
   * @generated from field: repeated forms.v1.Field fields = 2;
   */
  fields: Field[]

  /**
   * @generated from field: string title = 3;
   */
  title: string

  /**
   * @generated from field: string description = 4;
   */
  description: string

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean

  /**
   * @generated from field: optional string action_text = 6;
   */
  actionText?: string

  /**
   * @generated from field: repeated forms.v1.Rule rules = 7;
   */
  rules: Rule[]
}

/**
 * Describes the message forms.v1.CreateFormRequest.
 * Use `create(CreateFormRequestSchema)` to create a new message.
 */
export const CreateFormRequestSchema: GenMessage<CreateFormRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 2)

/**
 * @generated from message forms.v1.Rule
 */
export type Rule = Message<'forms.v1.Rule'> & {
  /**
   * @generated from field: string id = 3;
   */
  id: string

  /**
   * @generated from field: repeated string field_keys = 1;
   */
  fieldKeys: string[]

  /**
   * JSON Schema which if evaluates to false given the current form state hides the form element
   *
   * @generated from field: string schema = 2;
   */
  schema: string
}

/**
 * Describes the message forms.v1.Rule.
 * Use `create(RuleSchema)` to create a new message.
 */
export const RuleSchema: GenMessage<Rule> = /*@__PURE__*/ messageDesc(file_forms_v1_forms, 3)

/**
 * @generated from message forms.v1.GetFormRequest
 */
export type GetFormRequest = Message<'forms.v1.GetFormRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message forms.v1.GetFormRequest.
 * Use `create(GetFormRequestSchema)` to create a new message.
 */
export const GetFormRequestSchema: GenMessage<GetFormRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 4)

/**
 * @generated from message forms.v1.GetFormResponse
 */
export type GetFormResponse = Message<'forms.v1.GetFormResponse'> & {
  /**
   * @generated from field: forms.v1.Form form = 1;
   */
  form?: Form
}

/**
 * Describes the message forms.v1.GetFormResponse.
 * Use `create(GetFormResponseSchema)` to create a new message.
 */
export const GetFormResponseSchema: GenMessage<GetFormResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 5)

/**
 * @generated from message forms.v1.RenderFormRequest
 */
export type RenderFormRequest = Message<'forms.v1.RenderFormRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message forms.v1.RenderFormRequest.
 * Use `create(RenderFormRequestSchema)` to create a new message.
 */
export const RenderFormRequestSchema: GenMessage<RenderFormRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 6)

/**
 * @generated from message forms.v1.RenderFormResponse
 */
export type RenderFormResponse = Message<'forms.v1.RenderFormResponse'> & {
  /**
   * @generated from field: forms.v1.Form form = 1;
   */
  form?: Form
}

/**
 * Describes the message forms.v1.RenderFormResponse.
 * Use `create(RenderFormResponseSchema)` to create a new message.
 */
export const RenderFormResponseSchema: GenMessage<RenderFormResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 7)

/**
 * Performs a PUT-style update, syncing all form state
 *
 * @generated from message forms.v1.UpdateFormRequest
 */
export type UpdateFormRequest = Message<'forms.v1.UpdateFormRequest'> & {
  /**
   * @generated from field: forms.v1.Form form = 1;
   */
  form?: Form
}

/**
 * Describes the message forms.v1.UpdateFormRequest.
 * Use `create(UpdateFormRequestSchema)` to create a new message.
 */
export const UpdateFormRequestSchema: GenMessage<UpdateFormRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 8)

/**
 * @generated from message forms.v1.UpdateFormResponse
 */
export type UpdateFormResponse = Message<'forms.v1.UpdateFormResponse'> & {
  /**
   * @generated from field: forms.v1.Form form = 1;
   */
  form?: Form
}

/**
 * Describes the message forms.v1.UpdateFormResponse.
 * Use `create(UpdateFormResponseSchema)` to create a new message.
 */
export const UpdateFormResponseSchema: GenMessage<UpdateFormResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 9)

/**
 * @generated from message forms.v1.ArchiveFormRequest
 */
export type ArchiveFormRequest = Message<'forms.v1.ArchiveFormRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message forms.v1.ArchiveFormRequest.
 * Use `create(ArchiveFormRequestSchema)` to create a new message.
 */
export const ArchiveFormRequestSchema: GenMessage<ArchiveFormRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 10)

/**
 * @generated from message forms.v1.ArchiveFormResponse
 */
export type ArchiveFormResponse = Message<'forms.v1.ArchiveFormResponse'> & {}

/**
 * Describes the message forms.v1.ArchiveFormResponse.
 * Use `create(ArchiveFormResponseSchema)` to create a new message.
 */
export const ArchiveFormResponseSchema: GenMessage<ArchiveFormResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 11)

/**
 * @generated from message forms.v1.ListFormsRequest
 */
export type ListFormsRequest = Message<'forms.v1.ListFormsRequest'> & {
  /**
   * @generated from field: optional forms.v1.PaginationOptions page_options = 3;
   */
  pageOptions?: PaginationOptions
}

/**
 * Describes the message forms.v1.ListFormsRequest.
 * Use `create(ListFormsRequestSchema)` to create a new message.
 */
export const ListFormsRequestSchema: GenMessage<ListFormsRequest> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 12)

/**
 * @generated from message forms.v1.ListFormsResponse
 */
export type ListFormsResponse = Message<'forms.v1.ListFormsResponse'> & {
  /**
   * @generated from field: repeated forms.v1.Form forms = 1;
   */
  forms: Form[]

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string
}

/**
 * Describes the message forms.v1.ListFormsResponse.
 * Use `create(ListFormsResponseSchema)` to create a new message.
 */
export const ListFormsResponseSchema: GenMessage<ListFormsResponse> =
  /*@__PURE__*/
  messageDesc(file_forms_v1_forms, 13)

/**
 * @generated from service forms.v1.FormsService
 */
export const FormsService: GenService<{
  /**
   * @generated from rpc forms.v1.FormsService.CreateForm
   */
  createForm: {
    methodKind: 'unary'
    input: typeof CreateFormRequestSchema
    output: typeof CreateFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.GetForm
   */
  getForm: {
    methodKind: 'unary'
    input: typeof GetFormRequestSchema
    output: typeof GetFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.RenderForm
   */
  renderForm: {
    methodKind: 'unary'
    input: typeof RenderFormRequestSchema
    output: typeof RenderFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.UpdateForm
   */
  updateForm: {
    methodKind: 'unary'
    input: typeof UpdateFormRequestSchema
    output: typeof UpdateFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.ArchiveForm
   */
  archiveForm: {
    methodKind: 'unary'
    input: typeof ArchiveFormRequestSchema
    output: typeof ArchiveFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.ListForms
   */
  listForms: {
    methodKind: 'unary'
    input: typeof ListFormsRequestSchema
    output: typeof ListFormsResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.SubmitForm
   */
  submitForm: {
    methodKind: 'unary'
    input: typeof SubmitFormRequestSchema
    output: typeof SubmitFormResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.ListSubmissions
   */
  listSubmissions: {
    methodKind: 'unary'
    input: typeof ListSubmissionsRequestSchema
    output: typeof ListSubmissionsResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.DeleteSubmission
   */
  deleteSubmission: {
    methodKind: 'unary'
    input: typeof DeleteSubmissionRequestSchema
    output: typeof DeleteSubmissionResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.BatchDeleteSubmission
   */
  batchDeleteSubmission: {
    methodKind: 'unary'
    input: typeof BatchDeleteSubmissionRequestSchema
    output: typeof BatchDeleteSubmissionResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.SubmissionsSummary
   */
  submissionsSummary: {
    methodKind: 'unary'
    input: typeof SubmissionsSummaryRequestSchema
    output: typeof SubmissionsSummaryResponseSchema
  }
  /**
   * buf:lint:ignore RPC_RESPONSE_STANDARD_NAME
   *
   * @generated from rpc forms.v1.FormsService.DownloadSubmissionsCSV
   */
  downloadSubmissionsCSV: {
    methodKind: 'unary'
    input: typeof DownloadSubmissionsCSVRequestSchema
    output: typeof HttpBodySchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.GetLiveResults
   */
  getLiveResults: {
    methodKind: 'server_streaming'
    input: typeof GetLiveResultsRequestSchema
    output: typeof GetLiveResultsResponseSchema
  }
  /**
   * @generated from rpc forms.v1.FormsService.BatchGetSubmissionSummaries
   */
  batchGetSubmissionSummaries: {
    methodKind: 'unary'
    input: typeof BatchGetSubmissionSummariesRequestSchema
    output: typeof BatchGetSubmissionSummariesResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_forms_v1_forms, 0)
